export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"key":"og:title","property":"og:title","content":"Remote developer jobs, work from anywhere - Proxify"},{"key":"og:description","name":"description","property":"og:description","content":"Find perfect remote software developer jobs tailored to your preferences. Join Proxify today to start your growth journey and work with global brands."},{"key":"og:type","property":"og:type","content":"website"}],"link":[{"rel":"icon","media":"(prefers-color-scheme: light)","href":"/favicon.png?v=3"},{"rel":"icon","media":"(prefers-color-scheme: dark)","href":"/favicon-white.png?v=3"}],"style":[],"script":[{"src":"/cookie-consent-mode.js","id":"cookieConsentMode","type":"text/javascript"},{"src":"https://cdn-cookieyes.com/client_data/935a3cd2b92ca13b9d045444/script.js","id":"cookieyes","type":"text/javascript","async":true}],"noscript":[],"title":"Remote developer jobs, work from anywhere - Proxify","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"